import { Component, inject, Input } from '@angular/core';
import { DataLayerStore } from '../../../stores/data-layer/data-layer.state';
import { CountBoxComponent } from '../../atoms/count-box/count-box.component';

@Component({
  selector: 'app-count-box-data-layer',
  standalone: true,
  imports: [CountBoxComponent],
  templateUrl: './count-box-data-layer.component.html',
  styleUrl: './count-box-data-layer.component.scss',
})
export class CountBoxDataLayerComponent {
  readonly store = inject(DataLayerStore);
  @Input() title = 'Jahre';
  @Input() text = '';
  @Input() styleClass = '';
}
